import {Button, Dropdown} from 'react-bootstrap';
import {IconBack} from '../../../../component/IconSvg';
import {ReactNode} from 'react';
import {OctKTSVG} from '@oceantech/oceantech-ui';

type Props = {
  onClose: () => void;
};

type Action = {
  label: string;
  icon?: ReactNode;
  onClick?: () => void;
};

const ACTIONS: Action[] = [
  {
    label: 'In',
    icon: <OctKTSVG path="/media/svg/cis/in.svg"/>
  },
  {
    label: 'Thuốc',
    icon: <OctKTSVG path="/media/svg/cis/thuoc.svg"/>
  },
  {
    label: 'Máu',
    icon: <OctKTSVG path="/media/svg/cis/ql-mau.svg"/>,
  },
  {
    label: 'Chi phí',
    icon: <OctKTSVG path="/media/svg/cis/chi-phi.svg"/>,
  },
];

const ActionButton = ({onClose}: Props) => {
  return (
    <div className="d-flex align-items-center gap-3">
      <Button
        variant="bg-transparent text-hover-primary ps-0 d-flex align-items-center"
        onClick={onClose}
      >
        <IconBack/>
        <span className="fw-500 ps-2">Quay lại</span>
      </Button>

      {ACTIONS.map((action: Action) => (
        <Button className="btn-fill spaces min-w-80" key={action.label}
                hidden={true}
        >
          {action.icon}
          <span>{action.label}</span>
        </Button>
      ))}

      <Dropdown className="dropdown-btn menu-icon" hidden={true}>
        <Dropdown.Toggle className="btn-fill spaces min-w-80" id="dropdown-benhan">
          <OctKTSVG path="/media/svg/cis/dieu-tri.svg"/>
          Điều trị
          <i className="bi bi-caret-down-fill spaces pt-2 pl-4 pr-0 mr-0"></i>
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-actions">
          <Dropdown.Item className="bg-light spaces line-height-30 text-dark fw-bold">
            Item
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default ActionButton;
